/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react-perf/jsx-no-new-object-as-prop */
/* eslint-disable react/jsx-indent */
/* eslint-disable sonarjs/prefer-immediate-return */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable line-comment-position */
/* eslint-disable no-undef */
/* eslint-disable func-style */
/* eslint-disable security/detect-object-injection */
/* eslint-disable react/destructuring-assignment */
import React, { Suspense } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import ErrorBoundaryFallback from '../ErrorBoundaryFallback'
import mfeErrorLog from '../../helpers/mfe/mfeErrorLog'
import useDynamicScript from './hooks/useDynamicScript'

const loadComponent = (scope, module) => async () => {
  // Initializes the share scope. This fills it with known provided modules from this build and all remotes
  await __webpack_init_sharing__('default')
  const container = window[scope] // or get the container somewhere else
  // Initialize the container, it may provide shared modules
  await container.init(__webpack_share_scopes__.default)
  const factory = await window[scope].get(module)
  const Module = factory()
  return Module
}

const ModuleLoader = props => {
  const { ready, failed } = useDynamicScript({
    url: props.module && props.url,
  })

  if (!props.module) {
    return (
      <ErrorBoundaryFallback
        error={{ message: 'Not Remote Module specified' }}
        template={props.fallbackTemplate}
      />
    )
  }

  if (failed) {
    return (
      <ErrorBoundaryFallback
        error={{ message: `Failed to load dynamic script: ${props.url}` }}
        template={props.fallbackTemplate}
      />
    )
  }

  if (!ready) {
    return null
  }

  const Component = React.lazy(loadComponent(props.scope, props.module))

  return (
    <ErrorBoundary
      FallbackComponent={ErrorBoundaryFallback}
      onError={mfeErrorLog}
    >
      <Suspense fallback={props?.fallbackSuspense || null}>
        {props.mfeComponentParameters ? (
          <Component {...props.mfeComponentParameters} />
        ) : <Component />}
      </Suspense>
    </ErrorBoundary>
  )
}

export default ModuleLoader
